import React from 'react'
import { connect } from 'react-redux'
import deepEquals from "deep-equal";

import { mapStateToPlaceOrderDetails } from '../PlaceOrder'
import { notifyError } from '../UserMessaging'

import CheckoutSummary from './CheckoutSummary'
import { refreshSummary, notifyRefreshingSummary } from "./checkoutSummaryActions";

function dependenciesChanged(props, prevProps) {
    const shippingMethodChanged = (props.selectedShippingOptionId !== prevProps.selectedShippingOptionId)
        || ((!!props.placeOrderDetails.SelectedShippingOption && props.placeOrderDetails.SelectedShippingOption.Id) !== (!!prevProps.placeOrderDetails.SelectedShippingOption && prevProps.placeOrderDetails.SelectedShippingOption.Id));

    const shippingAddressChanged = (props.selectedShippingAddressId !== prevProps.selectedShippingAddressId)
        || ((!!props.placeOrderDetails.SelectedShippingAddress && props.placeOrderDetails.SelectedShippingAddress.Id) !== (!!prevProps.placeOrderDetails.SelectedShippingAddress && prevProps.placeOrderDetails.SelectedShippingAddress.Id));

    return shippingMethodChanged || shippingAddressChanged || !deepEquals(props.cart, prevProps.cart);
}

class CheckoutSummaryContainer extends React.Component {
    componentDidUpdate(prevProps) {
        if (dependenciesChanged(this.props, prevProps)) {
            this.refreshSummaryWithDebounce(this.props.placeOrderDetails)
        } else if (
            !!this.props.summary.errorMessages
            && this.props.summary.errorMessages.length > 0
            && (!prevProps.summary.errorMessages
                || JSON.stringify(prevProps.summary.errorMessages) !== JSON.stringify(this.props.summary.errorMessages))
        ) 
        {
            this.props.onGetSummaryError('An error occurred refreshing the summary: \n' + this.props.summary.errorMessages.join("\n"))
        }
    }

    componentDidMount() {
        this.refreshSummaryWithDebounce(this.props.placeOrderDetails);
    }

    // Sometimes, especially at page load, refresh would be called multiple times in quick succession.
    refreshSummaryWithDebounce = (placeOrderDetails) => {
        if (!this.props.isRefreshing) {
            this.props.notifyRefreshingSummary();
        }
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.props.refreshSummary(placeOrderDetails);
        }, 1000);
    }

    render() {
        return React.createElement(CheckoutSummary,
            {
                summary: this.props.summary,
                isRefreshing: this.props.isRefreshing
            })
    }

}

const mapCheckoutSummaryStateToProps = state => {
    return {
        summary: state.entities.Summary,
        placeOrderDetails: mapStateToPlaceOrderDetails(state),
        cart: state.entities.CartItems,
        isRefreshing: state.entities.isRefreshingSummary,
        selectedShippingOptionId: state.entities.SelectedShippingOptionId,
        selectedShippingAddressId: state.entities.SelectedShippingAddressId
    }
}

const mapCheckoutSummaryDispatchToProps = dispatch => {
    return {
        onGetSummaryError: (diagnosticMessage) => dispatch(notifyError(diagnosticMessage, diagnosticMessage)),
        notifyRefreshingSummary: () => dispatch(notifyRefreshingSummary()),
        refreshSummary: (placeOrderDetails) => dispatch(refreshSummary(placeOrderDetails))
    }
}

const ConnectedCheckoutSummary = connect(mapCheckoutSummaryStateToProps, mapCheckoutSummaryDispatchToProps)(CheckoutSummaryContainer)

export default ConnectedCheckoutSummary